import { Icon, Icons } from '@silverfort/sf-components';
import { ServiceAccountData } from '../../ServiceAccountsTypes';

export const RemoveReasonOptionsByType = {
    hide: [
        {
            title: 'Account passwords are vaulted or frequently rotated',
            value: 'Account passwords are vaulted or frequently rotated'
        },
        { title: 'Accounts have low impact', value: 'Accounts have low impact' }
    ],
    remove: [
        { title: 'User accounts (not NHI)', value: 'User accounts (not NHI)' },
        { title: 'Shared accounts (not NHI)', value: 'Shared accounts (not NHI)' }
    ]
};

const removedReason = (serviceAccount: ServiceAccountData) =>
    serviceAccount.remove_reason === 'hidden' ? 'Hide' : 'Misclassificiation';

export const ServiceAccountRemoveReason = ({ serviceAccount }: { serviceAccount: ServiceAccountData }) => {
    return (
        <div className="border border-sf-gray-100 rounded-lg p-4 m-4 w-full">
            <div className="flex flex-row ">
                <Icon size={24} icon={Icons.CircleInfo} className="text-sf-primary-500 bg-sf-primary-100" />
                <div className="ml-4 flex flex-col">
                    <div className={`text-[16px] font-medium`}>{removedReason(serviceAccount)}</div>
                    <div className={`text-[13px] font-normal text-sf-gray-500 pt-2`}>
                        <div>
                            Reason: {serviceAccount.custom_ui_remove_reason || serviceAccount.ui_remove_reason || '-'}
                        </div>
                        Additional information: {serviceAccount.ui_remove_details || '-'}
                    </div>
                </div>
            </div>
        </div>
    );
};
